import { render, staticRenderFns } from "./LogoCloud.vue?vue&type=template&id=16540f48&"
import script from "./LogoCloud.vue?vue&type=script&lang=js&"
export * from "./LogoCloud.vue?vue&type=script&lang=js&"
import style0 from "./LogoCloud.vue?vue&type=style&index=0&id=16540f48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports